export default __webpack_public_path__ + "static/media/mindset-traveler.5d9aaef1.svg";